import {createSelector} from 'reselect';
import {getExperiment} from '../../ExperimentSelectors';

export default createSelector(
  [getExperiment],
  experiment => experiment?.apm_redesign_wave_02 === 'v1|checkout_btn_non_sticky',
);
